import axios from 'axios';
import type { Contato, PaginatedResult } from '@eleg360/types';

const API_URL = import.meta.env.VITE_API_URL || '/api';

export const contatosApi = {
  create: async (data: Omit<Contato, 'id' | 'tenant_id' | 'created_at' | 'updated_at'>, token: string) => {
    const res = await axios.post<Contato>(`${API_URL}/gab/contatos`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  list: async (filters: Record<string, any>, token: string) => {
    const res = await axios.get<PaginatedResult<Contato>>(`${API_URL}/gab/contatos`, {
      params: filters,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  /** Sem `dias`, lista os aniversariantes do mês corrente. */
  listBirthdays: async (token: string, filtros?: { dias?: number; bairro?: string }) => {
    const res = await axios.get<Contato[]>(`${API_URL}/gab/contatos/aniversariantes`, {
      params: filtros,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  get: async (id: string, token: string) => {
    const res = await axios.get<Contato>(`${API_URL}/gab/contatos/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  update: async (id: string, data: Partial<Contato>, token: string) => {
    const res = await axios.put<Contato>(`${API_URL}/gab/contatos/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/gab/contatos/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  importCsv: async (csvData: string, token: string) => {
    const res = await axios.post<{ success: boolean; count: number }>(
      `${API_URL}/gab/contatos/importar`,
      { csv: csvData },
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return res.data;
  },
};
